<template>
  <div class="test-list" v-if="show_body">
    <!-- 进度 -->
    <div class="progress" :style="{width: progress}"></div>
    <div class="pg-num">{{progress}}</div>
    <!-- 开始 -->
    <div ref="topic-header">
      <!-- 第一部分 头部 -->
      <div v-if="!lock" :class="[!lock ? 'item-answer-left-animation' : '','item-inter inter-left mt32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>{{intro}}</p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <!-- list -->
    <div v-for="(item, index) in list" :key="index+''">
      <!-- 数据渲染部分 -->
      <div ref="item-yield" v-show="yieldIndex + 2 >= index">
        <div :class="[yieldIndex >= index && !lock ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
          <div class="pull-left ico-box">
            <img src="../../../assets/cep_logo.png" alt="" />
          </div>
          <div class="item-text pull-left pr">
            <div class="alert-con item-radius">
              <p>{{item.question}}</p>
            </div>
            <div class="caret pa"></div>
          </div>
        </div>
        <!-- item-right -->
        <div :class="[yieldIndex >= index && !lock ? 'item-answer-right-animation' : '','item-inter inter-right pt32']">
          <div class="clearfix">
            <div class="pull-right ico-box">
              <img :src="headimgurl" alt="" />
            </div>
            <div class="item-text pull-right pr">
              <div class="alert-con item-radius">
                <van-radio-group class="alert-radio-group" v-model="item.radio">
                  <van-cell-group>
                    <!-- <van-cell v-for="item2 in item.options" :key="item[1] + item.id" :class="item.radio == item2[1] ? 'active' : ''" :title="item2[0]" clickable @click="selectItemRadio(item, item2, index)"> -->
                    <van-cell v-for="item2 in item.options" :key="item[1]" :class="{active: item.radio === item2[1]}" :title="item2[0]" clickable @click="selectItemRadio(item, item2, index)">
                      <van-radio :checked-color="'#EB5032'" :name="item2[1]" />
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
              </div>
              <div class="caret pa"></div>
              <div v-if="yieldIndex < index && !lock" class="shelter"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 结束 自己 -->
    <div v-show="showFooter && !pattern">
      <div ref="cart-footer" :class="[showFooter ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>已完成全部测评！点击领取你的专业报告。</p>
            <a @click="over_click" class="text-right next-box measurement_public">生成报告 > </a>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <!-- 结束 别人 -->
    <div v-show="ta_show">
      <div ref="cart-footer" :class="[ta_show ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <!-- <p>你也来测测你的通用能力吧。</p> -->
            <p>你已完成对{{ta_nickname}}的能力评价，恭喜你也免费获得一份价值99元的“可迁移能力测评”资格</p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <!-- 结束 对话 -->
    <div v-show="ta_show">
      <div ref="cart-label" :class="[ta_show ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <!-- <p>完成测评后，你可以：洞察自己在思维能力、人际能力、任务管理和团队管理四维度12项能力现状，获知优劣势；也可以能邀请好友反馈，发现自己和别人对自己评价中的共识与差异。</p> -->
            <p>完成测评后，你将深度了解自己的能力现状，包括思维能力、人际能力、任务管理、团队管理四个维度的12项能力现状，如果邀请好友参加评价，还可以获得更全面和更准确的能力报告。</p>
            <a @click="goMyTestTask" v-show="ta_show" class="goTask-btns">点击开始测评 > > ></a>
            <p class="mt32">下面是报告部分内容样例</p>
            <img class="mt32" src="@a/cart-footer-data.png" alt="" />
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <!-- 自己 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="kc_show">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <!-- <img src="../../../assets/cep_ewm.png" /> -->
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 未购买 -->
    <van-popup class="pub_alert" v-model="is_buy" :close-on-click-overlay="false">
      <div class="confirm_box">
        <h2>此测评属于最佳工作模式课程，快去购买课程测评吧</h2>
        <div class="btn_group">
          <router-link class="confirm" :to="{
            path:'/course_details',
            query:{
              bid:2
            }
          }">购买最佳工作模式课程</router-link>
          <!-- <a class="confirm" href="javascript:;">购买最佳工作模式课程</a> -->
        </div>
      </div>
    </van-popup>
    <!-- 是否是本期次的学员 -->
    <van-popup class="pub_alert" v-model="periodOfTime" :close-on-click-overlay="false">
      <div class="confirm_box">
        <h2>{{periodOfVal}}</h2>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  ceping59_index,
  ceping59_answer,
  ceping59_ta_answer,
  ceping59_ta_index,
  ceping_event,
} from '@/api/measurement'
import {  queryString,getStorage, setStorage,deleteStorage} from '@/utils/tools'
import { shareCon} from '@/utils/wxconfig'
export default {
  data() {
      return {
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
        show_body: false,
        qrcode: "",
        intro: "",
        lock: true,
        //
        yieldIndex: 0,
        //
        headimgurl: "",
        headtitle: "职业发展健康指数测评",
        nickname: "",
        list: [],
        showFooter: false,
        kc_show: false,
        //
        ta_show: false,
        // 模式
        pattern: false,
        data: {},
        ta_nickname: '',
        is_buy: false,
        // 上一页面路由
        formPath:'',
        // 判断是否是本期次
        periodOfTime:false,
        periodOfVal:''
      }
    },
    computed: {
      progress() {
        return (Math.floor((this.yieldIndex / (this.list.length - 1)) * 100)>100?100:Math.floor((this.yieldIndex / (this.list.length - 1)) * 100) ) + '%';
      }
    },
    methods: {
      resetData() {
        this.intro = "";
        this.lock = true;
        //
        this.yieldIndex = 0;
        //
        this.headimgurl = "";
        this.headtitle = "职业发展健康指数测评";
        this.nickname = "";
        this.list = [];
        this.showFooter = false;
        this.kc_show = false;
        //
        this.ta_show = false;
        // 模式
        this.pattern = false;
      },
      goMyTestTask() {
        this.resetData();
        this.pullData();
        this.$router.push('/measurement_public_p1');
      },
      selectItemRadio(item, item2, index) {
        if (!this.pattern) {
          setStorage(this.$route.path, String(item.cid)+String(item.id), item2[1]);
        }
        // 如果没有选择
        let isLastEl = (index + 1) < this.list.length;
        if (!item.radio && isLastEl) {
          this.yieldIndex++;
          this.setScrollTo(index);
        }

        // 最后一个
        if (!item.radio && !isLastEl) {
          this.showFooter = true;
          let el = this.$refs['cart-footer'];

          this.setScrollTo(false, true, el, () => {
            if (this.pattern) {
              this.over_click();
            }
          });
        }
        item.radio = item2[1];

        let is_complete = (index == this.list.length - 1) ? true : false;

        this.$forceUpdate();

        // 神策统计--选择选项时触发
        // sensors.track('doQuestions', {
        //   evaluation_id: 49,
        //   evaluation_name: this.data.headtitle,
        //   questions_number: this.data.progress += 1,
        //   questions_topic: item.question,
        //   questions_option: item2[0],
        //   is_complete_question: is_complete,
        //   share_user_id: this.$route.query.share_uid || "",
        //   channel_name: this.$route.query.channel || ""
        // });
      },
      setScrollTo(index, bool, el, cb) {
        setTimeout(() => {
          let elTop = bool ? el.offsetTop - 10 : this.$refs['item-yield'][index + 1].offsetTop - 10;
          let scroll = document.documentElement.scrollTop ? document.documentElement : document.body;

          if (!bool || elTop > 0) {
            // window.scrollTo({
            //     top: elTop,
            //     behavior: "smooth"
            // });

            this.scrollSmoothTo(elTop);
          }
          if (cb) cb();
        }, 100)
      },
      scrollSmoothTo(position) {
        if (!window.requestAnimationFrame) {
          window.requestAnimationFrame = function(callback, element) {
            return setTimeout(callback, 17);
          };
        }
        // 当前滚动高度
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        // 滚动step方法
        var step = function() {
          // 距离目标滚动距离
          var distance = position - scrollTop;
          // 目标滚动位置
          scrollTop = scrollTop + distance / 5;
          if (Math.abs(distance) < 1) {
            window.scrollTo(0, position);
          } else {
            window.scrollTo(0, scrollTop);
            requestAnimationFrame(step);
          }
        };
        step();
      },
      createData() {
        let arr = [];
        for (let arg of this.list) {
          arr.push({
            qid: arg.id,
            cid: arg.cid,
            eid: arg.eid,
            score: arg.radio
          })
        }
        return arr
      },
      over_click() {
        let q = this.$route.query;
        let result = this.createData();

        if (!this.pattern) {
          // 自己
          ceping59_answer({
              answer: JSON.stringify(result)
            })
            .then((data) => {
              if (this.subscribe) {
                // 提交删除缓存
                deleteStorage(this.$route.path);
                let q = this.$route.query;
                if(this.formPath==='/ceping59_report'){
                  this.$router.back();
                }else{
                  this.$router.push({
                    path: '/ceping59_report',
                    query: {
                      uid: data.uid
                    }
                  })
                }
              } else {
                this.kc_show = true;

              }
            })
        } else {
          // 别人
          ceping59_ta_answer({
              ta_uid: q.ta_uid,
              answer: JSON.stringify(result)
            })
            .then((data) => {
              // 成功
              if (data.code != 10002) {
                // 弹出开始测试自己
                this.ta_show = true;
                let el = this.$refs['cart-label'];
                this.setScrollTo(false, true, el);
              }
            })
        }
      },
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        if (!this.pattern) {
          // 自己
          let q = this.$route.query;
          ceping59_index({
              share_uid: q.share_uid || "",
              channel: q.channel || ""
            })
            .then((data) => {
              this.$toast.clear();

              this.type_obj.evaluation_id = data.cid;          
              this.type_obj.evaluation_name = data.headtitle;          
              this.type_obj.evaluation_user_id = data.uid;          
              this.type_obj.nickname = data.nickname;          
              this.type_obj.path = this.$route.path;       
              if(data.show_msg){
                this.periodOfTime = true;
                this.periodOfVal = data.msg;
              }else{
                this.is_buy = !data.is_buy;   
              }
              shareCon("measurement_new", this, this.type_obj);

              if (data.code != 10002) {
                // 设置数据
                this.initCptData(data);
                // 显示
                this.show_body = true;

              } else {
                if(this.formPath==='/ceping59_report'){
                  this.$router.back();
                }else{
                  // 已经测评完成
                  this.$router.push('/ceping59_report');
                }

              };

              ceping_event({ lead_sid: this.$route.query.lead_sid,
                cid: data.cid,
                event: 'ViewIndex',
              }).then(res=>{
                // 页面访问统计
              });

              // 神策统计--打开页面时触发
              // sensors.track('evaluationPage', {
              //   evaluation_id: String(data.cid),
              //   evaluation_name: data.headtitle,
              //   evaluation_url: window.location.href,
              //   evaluation_page_title: data.headtitle,
              //   share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
              // })
            })
        } else {
          // 别人
          ceping59_ta_index({
              "ta_uid": this.$route.query.ta_uid
            })
            .then((data) => {
              this.ta_nickname = data.ta_nickname;
              this.$toast.clear();

              this.type_obj.evaluation_id = data.cid;          
              this.type_obj.evaluation_name = data.headtitle;          
              this.type_obj.evaluation_user_id = data.uid;          
              this.type_obj.nickname = data.nickname;          
              this.type_obj.path = this.$route.path;          
              shareCon("measurement_new", this, this.type_obj);
              this.show_body = true;
              let off = data.uid == this.$route.query.ta_uid;
              if (off) {
                // 自己评自己
                this.$router.push('/ceping59_report');
                return
              }
              if (data.code != 10002) {
                // 设置数据
                this.initCptData(data);
                // 显示
              } else {
                // 已经给别人测评过
                this.ta_show = true;
                this.ta_nickname = data.data.ta_nickname
              };
            })
        }

      },
      initCptData(data) {
        this.subscribe = data.subscribe;
        if (!data.need_subscribe) {
          this.subscribe = true;
        }
        this.qrcode = data.qrcode;
        this.intro = data.intro;
        //
        this.headimgurl = data.headimgurl;
        this.headtitle = data.headtitle;
        this.nickname = data.nickname;
        this.data = data;
        //
        for (let arg of data.list) {
          arg.show = false;
          arg.radio = 0;
        }
        this.list = data.list;
        if (!this.pattern) {
          // 去取缓存已经答完题的数据
          let index_ = null;
          this.list.forEach((item,index)=>{
            item['radio'] = getStorage(this.$route.path, String(item.cid)+String(item.id));
            if(getStorage(this.$route.path, String(item.cid)+String(item.id)) || String(getStorage(this.$route.path, String(item.cid)+String(item.id)))==='0'){
              index_= index;
            }
          });
          // 如果以有缓存就显示下一个故+1
          this.yieldIndex+=(!index_&&index_!=0?0:(index_+1));
          if(index_){
            this.setScrollTo((index_+1)==this.list.length?index_-1:index_);
          }
          let  isLastEl= index_ + 1 < this.list.length;
          // 最后一个
          if (!isLastEl) {
            this.showFooter = true;
          }
        }
        // 第一屏进入
        this.list[0].show = true;
        this.lock = false;
        document.title = this.headtitle;
      },
      setPattern() {
        let isMy = this.$route.query.ta_uid;
        if (isMy) {
          this.pattern = true;
        } else {
          this.pattern = false;
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm=>{          //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.setPattern();
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.test-list {
  padding: 32px;
  overflow-x: hidden;
  padding-bottom: changeRem(10)+px;
}

.progress {
  position: fixed;
  height: 8px;
  left: 0;
  top: 0;
  z-index: 3;
  background: red;
  transition: all .3s;
}

.pg-num {
  position: fixed;
  padding: 10px;
  top: 10px;
  right: 10px;
  z-index: 4;
  background: red;
  transition: all .3s;
  color: #fff;
  border-radius: 30px;
}

.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425)+px;
}

.item-inter {
  transform: translateY(0px);
  opacity: 0;
  .ico-box {
    width: changeRem(1.75)+px;
    height: changeRem(1.75)+px;
    border-radius: changeRem(1.75)+px;
    overflow: hidden;
    img {
      max-width: 100%;
    }
  }
  .pd-row-2 {
    margin-top: 24px;
  }
  .item-text {
    font-size: changeRem(0.6)+px;
  }
  .item-radius {
    border-radius: changeRem(0.17)+px;
  }
  .alert-con {
    overflow: hidden;
    img {
      max-width: 100%;
    }
  }
  .active_a {
    color: #EB5032;
    text-decoration: underline;
  }
}


/* 左 */

.inter-left {
  .ico-box {
    left: 5px;
    top: 5px;
  }
  .item-text {
    margin-left: changeRem(0.5)+px;
    max-width: 465px;
    color: #fff;
  }
  .alert-con {
    padding: changeRem(0.425)+px;
    background: #F57F17;
  }
  .caret {
    width: 0px;
    height: 0px;
    left: changeRem(-0.3)+px;
    top: changeRem(0.1)+px;
    margin-top: changeRem(0.7)+px;
    border-top: changeRem(0.2)+px solid rgba(245, 127, 23, 0);
    border-right: changeRem(0.3)+px solid rgba(245, 127, 23, 1);
    border-bottom: changeRem(0.2)+px solid rgba(245, 127, 23, 0);
  }
}


/* 右 */

.inter-right {
  .item-text {
    margin-right: changeRem(0.5)+px;
  }
  .alert-con {
    background: #fff;
  }
  .caret {
    width: 0px;
    height: 0px;
    right: changeRem(-0.3)+px;
    top: changeRem(0.1)+px;
    margin-top: changeRem(0.7)+px;
    border-top: changeRem(0.2)+px solid rgba(255, 255, 255, 0);
    border-left: changeRem(0.3)+px solid rgba(255, 255, 255, 1);
    border-bottom: changeRem(0.2)+px solid rgba(255, 255, 255, 0);
  }
  .shelter {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
  }
}

.next-box {
  display: block;
  color: #fff;
  border-top: 2px solid #fff;
  margin-top: changeRem(0.35)+px;
  padding-top: changeRem(0.35)+px;
}

.item-answer-left-animation {
  animation: item-answer-animation 0.8s;
  animation-fill-mode: forwards;
}

.item-answer-right-animation {
  animation: item-answer-animation 0.8s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

.pop {
  img {
    max-width: 8rem;
  }
}

.pop2 {
  width: 7rem;
  padding: 0.2rem;
  color: #333;
  font-size: 0.4rem;
  text-align: justify;
  .block-btn {
    border: none;
    background: #F57F17;
    width: 100%;
    height: 1rem;
    border-radius: 0.1rem;
    color: #fff;
  }
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.goTask-btns {
  display: block;
  text-align: center;
  margin-top: 30px;
  border-top: 2px solid #fff;
  border-bottom: 2px solid #fff;
  padding: 20px 0 20px;
  font-size: 34px;
  color: #fff;
  text-align: right;
  animation: runMoveColor 5s infinite;
}

.confirm_box {
  h2 {
    padding-bottom: 12px;
    padding: 40px 30px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm {
      width: 100%;
    }
  }
}
</style>
<style>
@keyframes runMoveColor {
  0% {
    color: #fff;
  }
  50% {
    color: green;
  }
  100% {
    color: #fff;
  }
}

.active {
  color: #EB5032;
  font-weight: bold;
}

.alert-radio-group .van-cell {
  font-size: 0.37rem;
  line-height: 0.64rem;
  position: relative;
  border-bottom: 2px solid #ddd;
}

.alert-radio-group .van-cell:last-child {
  border-bottom: none;
}

.alert-radio-group .van-radio__icon {
  height: 0.55rem;
  line-height: 0.53rem;
}

.alert-radio-group .van-cell__title {
  position: relative;
  z-index: 1;
}

.alert-radio-group .van-radio__icon .van-icon {
  width: 0.53rem;
  height: 0.53rem;
  border-width: 2px;
}

.alert-radio-group [class*=van-hairline]::after {
  border: none;
}

.alert-radio-group .van-cell:not(:last-child)::after {
  border: none;
}

.alert-radio-group .van-cell__title span {
  display: block;
  width: 6rem;
  margin-right: -0.6rem;
  padding-right: 0.65rem;
}


/* 动画 */

@keyframes item-answer-animation {
  0% {
    transform: translateY(80px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>
